import { Box } from 'lucide-react';

export const SectionListSkillItem = ({ title }: { title: string }) => {
  return (
    <div className="bg-gray-800 p-4 rounded flex items-center">
      {/* TODO: Update icon as prop */}
      <Box className="text-green-400 w-6 h-6 mr-2" />
      <p>{title}</p>
    </div>
  );
};
